import type { IExtraReport, ITrackerClass, ITrackerConstructor, TTrackEvt } from '@/types/wiseTracker.ts';
import { WiseTracker } from '@/core/WiseTracker.ts';
import type { IBaseTrackData, IDataStore, IParamData } from '@/types/DataStore.ts';

let tracker: ITrackerClass;
export const core = {
  init(opts: ITrackerConstructor) {
    tracker = new WiseTracker(opts);
    if (!opts.manual) {
      tracker.autoTrack();
    }
    console.log('core init: ', tracker);
    return tracker;
  },
  track(evtName: TTrackEvt, params?: IParamData, ...arg: (undefined | string | IExtraReport)[]) {
    console.log('evtName: ', evtName, tracker);
    tracker.track(evtName, params, ...arg);
  },
  insert(opts: IBaseTrackData) {
    tracker.insert(opts);
  },
  getDataStoreInstance(): IDataStore {
    return tracker.getDataStoreInstance();
  },
  getTrackerInstance() {
    return tracker;
  },
};

export default core;
